import { profilePath } from '@/app/routes/paths';

export function buildProfileShareUrl(username: string): string {
  const path = profilePath(username);
  if (typeof window === 'undefined') {
    return path;
  }
  return `${window.location.origin}${path}`;
}
